import { css } from '@emotion/core';

export default css`
  margin-bottom: 10px;
`;
